var map = {
	"./Auth/ConfirmPassword.vue": 9476,
	"./Auth/ForgotPassword.vue": 3668,
	"./Auth/Login.vue": 9860,
	"./Auth/LoginEmail.vue": 2981,
	"./Auth/Register.vue": 8853,
	"./Auth/ResetPassword.vue": 6267,
	"./Auth/VerifyEmail.vue": 8938,
	"./Contact.vue": 9056,
	"./Home.vue": 596,
	"./Quiz.vue": 3019,
	"./Statistics.vue": 8719,
	"./Test.vue": 6413,
	"./Welcome.vue": 3680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6634;